import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Customers } from '@/models/Customer.model';

// Inital state
const state: Customers = {
  customers: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Customers> = {
  customers: (state) => state.customers,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Customers> = {
  setCustomers(state, { customers }) {
    state.customers = customers;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Customers, Mutations, Getters> = {
  setCustomers({ commit }, payload) {
    commit('setCustomers', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Customers, Getters, Mutations, Actions>('CustomerModule');

export const CustomersModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
